import { api } from "./Api";

export const getAllSpeakers = async () => {
  return api.get(`/admin/speaker?offset=0&limit=999`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    responseType: "json",
  });
};
